import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilePdf = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_3740_5660",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#232930"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_3740_5660)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.375 14.8125H7.5V12.5625H8.625C8.94375 12.5625 9.21094 12.4547 9.42656 12.2391C9.64219 12.0234 9.75 11.7562 9.75 11.4375V10.3125C9.75 9.99375 9.64219 9.72656 9.42656 9.51094C9.21094 9.29531 8.94375 9.1875 8.625 9.1875H6.375V14.8125ZM7.5 11.4375V10.3125H8.625V11.4375H7.5ZM10.875 14.8125H13.125C13.4437 14.8125 13.7109 14.7047 13.9266 14.4891C14.1422 14.2734 14.25 14.0062 14.25 13.6875V10.3125C14.25 9.99375 14.1422 9.72656 13.9266 9.51094C13.7109 9.29531 13.4437 9.1875 13.125 9.1875H10.875V14.8125ZM12 13.6875V10.3125H13.125V13.6875H12ZM15.375 14.8125H16.5V12.5625H17.625V11.4375H16.5V10.3125H17.625V9.1875H15.375V14.8125ZM5.25 21C4.63125 21 4.10156 20.7797 3.66094 20.3391C3.22031 19.8984 3 19.3688 3 18.75V5.25C3 4.63125 3.22031 4.10156 3.66094 3.66094C4.10156 3.22031 4.63125 3 5.25 3H18.75C19.3688 3 19.8984 3.22031 20.3391 3.66094C20.7797 4.10156 21 4.63125 21 5.25V18.75C21 19.3688 20.7797 19.8984 20.3391 20.3391C19.8984 20.7797 19.3688 21 18.75 21H5.25Z",
			fill: "currentColor"
		})
	})]
});
export default SvgFilePdf;
